/**
 * Popover for 3-lines-text type field editing on editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
// import { Label, InputArea, TextArea } from 'wix-style-react'
// import TextIcon from 'react-icons/lib/fa/font'
// import StyleIcon from 'react-icons/lib/fa/paint-brush'

import PopoverHeader from './PopoverHeader'
// import CustomTabs from './CustomTabs'
import CustomCSSView from './customCSS/CustomCSSView'

// controllers
import { setCustomFieldArray } from '../../../controllers/logic'


const Container = styled.div`
  _height: 26em;
  width: 20em;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`
const TextInputContainer = styled.div`
  padding: 1.3em 1.5em 1.3em 1.5em;
`
const Content = styled.div`
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  background-color: #fff;
`

class BulletPoints extends Component {

  state = {
    activeTab: 0
  }

  componentWillMount () {
    this.props.updatePosition('15%', '57%')
  }

  onItemClick = (item) => {
    this.setState({
      activeTab: item.id
    })
  }

  renderEditCSS () {
    return (
      <CustomCSSView
        field={this.props.field}
        app={this.props.app}
      />
    )
  }

  onInputChange = (i) => {
    return (e) => {
      const { value } = e.target
      // console.log('onInputChange', value)
      const { app, dispatch, paths } = this.props
      if (paths[i]) {
        dispatch(setCustomFieldArray(app.id, paths[i], value))
      }
    }
  }

  renderEditText (i) {
    return null
    // const { values } = this.props
    // return (
    //   <TextArea key={i}>
    //     <Label
    //       appearance='T1.1'
    //       for='firstName'
    //     >
    //       Edit Text
    //     </Label>
    //     <InputArea
    //       id='firstName'
    //       maxHeight='80px'
    //       maxLength={240}
    //       minHeight='40px'
    //       value={values[i]}
    //       placeholder={values[i]}
    //       rows={2}
    //       theme='normal'
    //       onChange={this.onInputChange(i)}
    //     />
    //   </TextArea>
    // )
  }

  renderTextFields () {
    const { paths } = this.props
    return (
      <TextInputContainer>
        {paths.map((path, i) => this.renderEditText(i))}
      </TextInputContainer>
    )
  }

  renderContent () {
    switch (this.props.popoverSection) {
      case 'text':
        return this.renderTextFields()
      case 'design':
        return this.renderEditCSS()
      default:
        return null
    }
  }

  render () {
    const { app, field, title, closeMyself } = this.props
    return (
      <Container>
        <PopoverHeader
          headingDescriptor={'Design '}
          title={title}
          onClose={closeMyself}
          helpTooltip={'Input a text for the field'}
          app={app}
          field={field}
        />
        <Content>
          {/*<CustomTabs*/}
          {/*activeTab={this.state.activeTab}*/}
          {/*onClick={this.onItemClick}*/}
          {/*tabsInfo={[{icon: TextIcon, name: 'Text'}, {icon: StyleIcon, name: 'Style'}]}*/}
          {/*/>*/}
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}

BulletPoints.propTypes = {
  closeMyself: PropTypes.func,
  // values: PropTypes.array,
  paths: PropTypes.array,
  title: PropTypes.string,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
  popoverSection: PropTypes.string
}

export default connect()(BulletPoints)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/BulletPointsPopover.js